export default __webpack_public_path__ + "static/media/chevron-down-small.dc0e79da.svg";